import { IconProps } from '@models/icons';

function MoreIcon(props:IconProps) {
    return (
        <svg width="57" height="8" viewBox="0 0 57 8" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...props} >
            <path d="M34.1729 3.49049C35.541 2.26637 34.6751 9.66453e-06 32.8393 9.50403e-06L24.3087 8.75827e-06C22.4729 8.59777e-06 21.607 2.26637 22.9751 3.49049L27.2404 7.3068C27.9997 7.98615 29.1483 7.98615 29.9076 7.3068L34.1729 3.49049Z" fill="#DEE1E4"/>
        </svg>
    );
}

export default MoreIcon;
